"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Request =
/*#__PURE__*/
function () {
  function Request(connector) {
    _classCallCheck(this, Request);

    this.connector = connector;
  }

  _createClass(Request, [{
    key: "to",
    value: function to(_to) {
      this.connector.historyManager.push(this.normarizeTo(_to));
    }
  }, {
    key: "name",
    value: function name(_name) {
      var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathname = this.connector.routeMatcher.compileByName(_name, parameters);
      this.connector.historyManager.push(pathname);
    }
  }, {
    key: "isActive",
    value: function isActive(pathname) {
      var location = this.connector.historyManager.getLocation();
      return location.pathname === pathname;
    }
  }, {
    key: "normarizeTo",
    value: function normarizeTo(to) {
      if (to[0] === "#") {
        return to.substr(1);
      }

      return to;
    }
  }]);

  return Request;
}();

var _default = Request;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./node_modules/async-react-router/lib/Request.js
// module id = 130
// module chunks = 0